import { Link } from "react-router-dom";

const ProfessionalCorporateServices = () => {
    return (
        <section className="bg-primary">
            <div className="max-w-7xl mx-auto px-4">
                <div className="py-20 md:py-28">

                    <div className="text-center">

                        <p className="text-white/70 text-sm uppercase tracking-widest">
                            Corporate Travel
                        </p>

                        <h1 className="mt-4 text-white text-4xl md:text-6xl font-bold max-w-5xl mx-auto leading-tight">
                            Benefits Of Professional Corporate Transportation Services
                        </h1>

                        <div className="mt-8 flex flex-wrap justify-center gap-4 text-white/70">
                            <span>June 8, 2026</span>
                            <span>•</span>
                            <span>Velox Charter</span>
                        </div>

                    </div>

                </div>
            </div>

            <section className="bg-[#F9FAFB] py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4">

                    <div className="grid lg:grid-cols-12 gap-10">

                        <div className="lg:col-span-8">

                            <div className="bg-white rounded-[30px] overflow-hidden shadow-sm">

                                <img
                                    src="/images/cooperate-transportation.png"
                                    alt="Corporate Transportation"
                                    className="w-full h-[300px] md:h-[500px] object-cover"
                                />

                                <div className="p-8 md:p-12">

                                    <p className="text-[#666666] leading-8 text-lg">
                                        In today's fast-paced business environment,
                                        every detail contributes to a company's
                                        success—including how employees,
                                        executives, and clients travel.
                                        Professional corporate transportation
                                        services provide organizations with a
                                        dependable, efficient, and comfortable
                                        solution for business travel needs.
                                    </p>

                                    <p className="mt-6 text-[#666666] leading-8 text-lg">
                                        Whether it's airport transfers,
                                        executive meetings, conferences,
                                        client visits, or company events,
                                        professional transportation helps
                                        businesses maintain productivity while
                                        creating a positive impression on
                                        employees and guests.
                                    </p>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            1. Improves Professional Image
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            First impressions matter in business.
                                            Providing professional transportation
                                            for clients, executives, and business
                                            partners demonstrates attention to
                                            detail and commitment to exceptional
                                            service.
                                        </p>

                                        <ul className="mt-5 space-y-3 text-[#666666]">
                                            <li>✓ Demonstrates professionalism</li>
                                            <li>✓ Creates a premium client experience</li>
                                            <li>✓ Reinforces brand reputation</li>
                                            <li>✓ Supports executive-level travel expectations</li>
                                        </ul>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            2. Increases Productivity During Travel
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Driving through traffic, finding
                                            parking, and navigating unfamiliar
                                            locations can be stressful and
                                            time-consuming. Professional
                                            transportation allows passengers to
                                            focus on work instead of travel
                                            logistics.
                                        </p>

                                        <div className="grid sm:grid-cols-2 gap-4 mt-6">
                                            {[
                                                "Respond To Emails",
                                                "Join Virtual Meetings",
                                                "Review Presentations",
                                                "Prepare For Client Meetings",
                                            ].map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="bg-[#F8FAFC] border rounded-[16px] p-5"
                                                >
                                                    {item}
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            3. Reduces Travel-Related Stress
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Professional transportation providers
                                            eliminate concerns related to traffic,
                                            parking, airport schedules, and route
                                            planning so employees can focus on
                                            their responsibilities with confidence.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            4. Provides Reliable Airport Transportation
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Airport transportation is one of the
                                            most common uses of corporate
                                            transportation services. Reliable
                                            pickups and drop-offs help travelers
                                            stay on schedule and reduce stress.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            5. Supports Employee Transportation Programs
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Employee shuttle services improve
                                            workforce mobility, reduce commuting
                                            stress, and contribute to employee
                                            satisfaction and retention.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            6. Enhances Safety
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Professional transportation companies
                                            prioritize safety through routine
                                            inspections, preventative maintenance,
                                            experienced drivers, and strict
                                            operational standards.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            7. Offers Flexible Transportation Solutions
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Every organization has unique travel
                                            requirements. Professional providers
                                            can customize transportation plans
                                            based on passenger count, schedules,
                                            and destinations.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            Final Thoughts
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Professional corporate transportation
                                            services help organizations improve
                                            efficiency, enhance professionalism,
                                            reduce stress, and create a better
                                            experience for employees, executives,
                                            and clients.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Whether you're arranging executive
                                            transportation, airport transfers,
                                            employee shuttles, or corporate event
                                            travel, partnering with a trusted
                                            transportation provider can make a
                                            significant difference in the overall
                                            experience.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="lg:col-span-4">
                            <div className="space-y-8">
                                <div className="bg-primary rounded-[24px] p-8 text-center">
                                    <h3 className="text-white text-2xl font-semibold">
                                        Need Transportation For Your Business?
                                    </h3>

                                    <p className="mt-4 text-white/80">
                                        Our corporate transportation solutions
                                        are designed to keep your business moving.
                                    </p>

                                    <Link
                                        to="/contact-us"
                                        className="mt-4 inline-block bg-white text-primary px-8 py-4 rounded-full font-semibold hover:scale-105 transition-all"
                                    >
                                        Contact Us
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </section>
    );
};

export default ProfessionalCorporateServices;